import {formatDateTime} from "../../../util/formatter";

interface NotificationHeadProps {
    subject: string;
    sent_dtm: string;
}

export default function NotificationHead({subject, sent_dtm}: NotificationHeadProps) {
    return <div className="notification-head">
        <h3 className="heading heading--montserrat heading--left">
            {subject}
        </h3>
        <time className="timestamp">
            {formatDateTime(sent_dtm)}
        </time>
    </div>
}
